import { render } from "./AccountBilling.vue?vue&type=template&id=2ed2e46b&scoped=true"
import script from "./AccountBilling.vue?vue&type=script&lang=js"
export * from "./AccountBilling.vue?vue&type=script&lang=js"

import "./AccountBilling.vue?vue&type=style&index=0&id=2ed2e46b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed2e46b"]])

export default __exports__